// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/electrical-system.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/electrical-system/electrical-system.js';

mount([g0]);
